import React from 'react';
import { OrderStatusEnum } from '@/main/services/enum/OrderStatusEnum';
import { useStyles } from './styles';

interface OrderStatusResponse {
  id: number;
  name: string;
}

interface IOrderStatusProps {
  status: OrderStatusResponse;
  guidSupplier: string;
  deliveryBySupplier: boolean;
  name: string;
  guidProcurementSupplier: string,
  guidProcurementStatusCompany: string;
  idProcurementStatusCompany: number;
  handleOpenInfoSide: (
    guidSupplier: string,
    deliveryBySupplier: boolean,
    statusSupplier: number,
    open: boolean,
    guidProcurementSupplier: string,
    guidProcurementStatusCompany: string,
    idProcurementStatusCompany: number,
  ) => void;
}

export function renderColorOrderStatus(id: number) {
  switch (id) {
    case OrderStatusEnum.Assigned:
      return '#999999';
    case OrderStatusEnum.Transit:
      return '#fab01c';
    case OrderStatusEnum.Delivered:
      return '#ff6600';
    case OrderStatusEnum.Invoiced:
      return '#0d47a1';
    case OrderStatusEnum.Paid:
      return '#06d032';
    case OrderStatusEnum.Returned:
      return '#06d032';
    case OrderStatusEnum.Received:
      return '#927896'
    case OrderStatusEnum.CancelProcess:
      return '#e66565'
    case OrderStatusEnum.ReturnProcess:
      return '#e6c565'
    default:
      return '#000';
  }
};

export default function OrderStatusComponent({
  status,
  guidSupplier,
  deliveryBySupplier,
  name,
  guidProcurementSupplier,
  guidProcurementStatusCompany,
  idProcurementStatusCompany,
  handleOpenInfoSide,
}: IOrderStatusProps) {
  const classes = useStyles();
  function handleClickButtonStatus() {
    handleOpenInfoSide(
      guidSupplier,
      deliveryBySupplier,
      status.id,
      true,
      guidProcurementSupplier,
      guidProcurementStatusCompany,
      idProcurementStatusCompany
    );
  }


  return (
    <div
      className={`d-flex align-items-center justify-content-center ${classes.container}`}
      style={{ backgroundColor: renderColorOrderStatus(status.id), cursor: 'pointer' }}
      title={name}
      onClick={handleClickButtonStatus}
    >
      <span className={classes.spanContainer}>{name}</span>
    </div>
  );
}
